import { CategoryFacetViewModel } from '@/types/api';
import { getBaseURL } from '@/features/navigation/utils/url-helpers';
import { NavigationCarousel } from '@/features/carousel';
import { EasyAccess } from '@/features/tag';
import { PLPPages } from '@/app/(plp)/types';
import { toNumberCommas } from '@/utils/string-helpers';
interface Props {
  categories: CategoryFacetViewModel[];
}
const MobileCategories = ({
  categories
}: Props) => {
  return <div data-test='next-level-categories-list' className='mb-4 flex w-full lg:hidden' data-sentry-component="MobileCategories" data-sentry-source-file="mobile.tsx">
            <NavigationCarousel className='flex' options={{
      perView: 'auto',
      spacing: 4,
      mode: 'free'
    }} data-sentry-element="NavigationCarousel" data-sentry-source-file="mobile.tsx">
                {categories?.map(category => <div key={category.key} className='w-full min-w-fit max-w-fit overflow-visible whitespace-nowrap'>
                        <EasyAccess size='medium' className='keen-slider__slide' href={'/' + getBaseURL({
          page: PLPPages.Categories,
          basicMetas: {
            breadcrumb: category.breadcrumb
          }
        })}>
                            {`${category.displayNameFa} ${category.count ? `(${toNumberCommas(category.count)})` : ''}`}
                        </EasyAccess>
                    </div>)}
            </NavigationCarousel>
        </div>;
};
export default MobileCategories;